<template>
  <div style="width: 100%; height: 100%">
    <div style="position: absolute; z-index: 999">
      <div class="block">
        <el-button type="info" @click="picker">舰队坐标插入</el-button>
        <el-button type="warning" @click="addword">下载word文档</el-button>
      </div>
      <el-input
        placeholder="请输入目标舰队名称"
        v-model="input"
        class="input-with-select"
      >
        <!-- <el-select
          v-model="select"
          slot="prepend"
          placeholder="请选择兵种"
          style="width: 120px"
        >
          <el-option label="海洋军种" value="1"></el-option>
        </el-select> -->
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="tracking"
        ></el-button>
      </el-input>
    </div>
    <div
      class="infoWindow"
      v-if="showBox"
      :style="{ left: tranLeft, top: tranTop }"
      v-drag
    >
      <h3 style="text-align: center">基地信息</h3>
      <i
        class="el-icon-close"
        @click="showBox = false"
        style="position: absolute; right: 5px; top: 5px; color: red"
      ></i>
      <div v-for="item in informationcard" :key="item">
        {{ item }}
      </div>
    </div>
    <div class="bar" id="main" ref="place_ref"></div>
    <el-dialog
      title="舰队坐标插入"
      :visible.sync="dialogVisible"
      width="60%"
      :before-close="handleClose">
      <el-form :model="numberValidateForm" ref="numberValidateForm" label-width="100px" class="demo-ruleForm">
        <el-form-item
          label="军种模块"
          prop="services"
          :rules="[
            { required: true, message: '军种模块不能为空'}
          ]"
        >
          <el-select v-model="numberValidateForm.services" placeholder="军种模块">
            <el-option label="兵力部署" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="舰队名称"
          prop="fleet_name"
          :rules="[
            { required: true, message: '舰队名称不能为空'}
          ]"
        >
          <el-input v-model="numberValidateForm.fleet_name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item
          label="时间"
          prop="time"
          :rules="[
            { required: true, message: '时间不能为空'},
          ]"
        >
            <el-date-picker
                v-model="numberValidateForm.time"
                type="date"
                placeholder="选择日期">
            </el-date-picker>
        </el-form-item>
         <el-col :span="12">
          <el-form-item
            label="经度"
            prop="longitude"
            :rules="[
              { required: true, message: '经度不能为空'},
            ]"
          >
            <el-input v-model="numberValidateForm.longitude" autocomplete="off"></el-input>
          </el-form-item>
         </el-col>
          <el-col :span="12">
          <el-form-item
            label="纬度"
            prop="latitude"
            :rules="[
              { required: true, message: '纬度不能为空'},
            ]"
          >
            <el-input v-model="numberValidateForm.latitude" autocomplete="off"></el-input>
          </el-form-item>
         </el-col>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="submitForm('numberValidateForm')">提交</el-button>
        <el-button type="primary" @click="resetForm('numberValidateForm')">重置</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const worldJson = require("./world.json");
import api from "@/services/python";
import "@/utils/directive.js";
import dataList from "./dataList.json";
export default {
  //  components:{
  //   timeline
  // },
  render: function (createElement) {
    return createElement("div", {
      attrs: {
        id: "main",
      },
      style: {
        top: "-260px !important",
        height: "1400px",
        width: "1600px",
        margin: "auto",
        overflow: "hidden",
      },
    });
  },
  data() {
    return {
      dialogVisible: false,
      showBox: false,
      tranLeft: 0, // 向左偏移
      tranTop: 0, // 向右偏移
      dataList: dataList,
      informationcard: [],
      timeAarry: [],
      geoList: [],
      input: "",
      // select: "",
      myChart: "",
      value1: "",
      options: {},
      numberValidateForm: {
          longitude: '',
          latitude:'',
          fleet_name:'',
          time:"",
          services:""
      },
      busLines: [],
      fleetlist: [],
    };
  },
  mounted() {
    this.getNowtime();
  },
  methods: {
     formatDateTime(timestamp) {
      if (!timestamp) {
        return null;
      } else {
        var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + "-";
        var M =
          (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) + "-";
        // var D = date.getDate() + " ";
        var D = date.getDate()
        var h =
          (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) +
          ":";
        var m =
          (date.getMinutes() < 10
            ? "0" + date.getMinutes()
            : date.getMinutes()) + ":";
        var s =
          date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        // return Y + M + D + h + m + s;
        if (Y + M + D + h + m + s== "NaN-NaN-NaN NaN:NaN:NaN") {
          return null;
        } else {
          // return Y + M + D + h + m + s; 带分秒的
          return Y + M + D;
        }
      }
    },
     handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
    },
     submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            // alert('submit!');
            this.dialogVisible = false;
            const params = {
              "services": Number(this.numberValidateForm.services),
              "fleet_name": this.numberValidateForm.fleet_name,
              "time": this.formatDateTime(this.numberValidateForm.time),
              "longitude": this.numberValidateForm.longitude,
              "latitude":this.numberValidateForm.latitude
            }
            console.log("params",params);
            api.situation.fleet_insert(params).response.then((res)=>res.data).then((res)=>{
              if(res.code == 200){
                this.$message.success("添加成功")
              }else{
                this.$message.error(res.msg)
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
    addword() {
      window.open("/基地列表.docx");
    },
    picker() {
      this.dialogVisible = true
    },
    tracking() {
      const params = {
        fleet_name: this.input,
      };
      api.situation
        .fleet_get(null, { params })
        .response.then((res) => res.data)
        .then((res) => {
          if (res.code == 200) {
            //  var hStep = 300 / (res.length - 1)
            var obj = eval(res.data); // 解析json数据
            // busLines=[];
            var points = [];
            for (var i = 0; i < obj.length; i++) {
              for (var j = 0; j < 1; j++) {
                // 这里有一个坑我必须说明一下 我的数据result8.json里经纬度反了，所以这里取值的时候先取的value[1],再取的value[0]
                points.push([obj[i].nodes[j].经度, obj[i].nodes[j].纬度]);
              }
              // 这里在组装连线的数据，下面将用到
            }
            const newbusLines = []
            newbusLines.push({
              coords: points, // 坐标这个数据是必须给的
              name: obj[0].nodes[0].名称, // 类似name还可以根据自己的需求给更多的数据
              lineStyle: {
                //给每条线都不同的样式
                normal: {
                  // color: this.echarts.color.modifyHSL('#F2E606', Math.round(hStep * i))
                  color: "#F2E606",
                },
              },
            });
            this.busLines = newbusLines
            console.log("busLines", this.busLines);
            // const _option = this.myChart.getOption();
            const nodes = res.data.map((item) => item.nodes);
            const fleetlist = [];
            for (var i = 0; i < nodes.length; i++) {
              for (var j = 0; j < 1; j++) {
                fleetlist.push({
                  name: nodes[0][0].名称,
                  value: Object.values(nodes[i][j]).slice(1),
                });
              }
            }
            console.log(fleetlist, "fleetlist");
            // this.options.series[2].data = [] // 清空之前的
            // this.fleetlist = nodes
            // const time = res.data.map((item) => item.time + "")
            // console.log("里根号",nodes,time);
            this.options.series[2].data = fleetlist;
            this.options.series[3].data =  this.busLines;
            this.options.series[4].data =  this.busLines;
            // this.options.timeline.data = time;
            // 加载数据
            this.myChart.setOption(this.options);
            console.log("_option", this.options);
          }
        });
    },
    getNowtime() {
      const params = {
        services: 0,
      };
      api.situation
        .troops_deploy(params)
        .response.then((res) => res.data)
        .then((res) => {
          if (res.code == 200) {
            this.timeAarry = res.data.map((item) => item.time + "");
            this.geoList = res.data.map((item) => item.nodes);
            // console.log("timeAarry2",timeAarry2);
            //  const geoList = res.data;
            // for(var i=0;i<geoList.length;i++) {
            //   const newgeolist =[]
            //   for(var j=0;j<geoList[i].nodes.length;j++) {
            //       newgeolist.push({
            //          "longitude": Number(geoList[i].nodes[j].经度),
            //         "latitude":  Number(geoList[i].nodes[j].纬度)
            //       })
            //    }
            //   this.geoList.push({
            //    newgeolist,
            // });
            // // console.log(newgeolist,"newgeolist");
            // }
            this.initEchart();
          }
        });
    },
    initEchart() {
      let dataList = this.dataList;
      for (let i = 0; i < dataList.length; i++) {
        dataList[i].value = Math.ceil(Math.random() * 1000 - 1);
      }
      const _this = this;
      this.myChart = this.echarts.init(document.getElementById("main"));
      this.echarts.registerMap("world", worldJson);

      console.log(this.timeAarry, this.geoList);

      var planePath =
        "path://M1705.06,1318.313v-89.254l-319.9-221.799l0.073-208.063c0.521-84.662-26.629-121.796-63.961-121.491c-37.332-0.305-64.482,36.829-63.961,121.491l0.073,208.063l-319.9,221.799v89.254l330.343-157.288l12.238,241.308l-134.449,92.931l0.531,42.034l175.125-42.917l175.125,42.917l0.531-42.034l-134.449-92.931l12.238-241.308L1705.06,1318.313z";
      var option = {
        tooltip: {
          //数据格式化
          formatter: function (params, callback) {
            return params.name + "：" + params.value;
            // return "国家" + "<br />" + params.name + "：" + params.value
          },
        },
        visualMap: {
          min: 0,
          max: 1000,
          left: "left",
          top: "490px",
          text: ["高", "低"], //取值范围的文字
          inRange: {
            color: [
              // 地图的颜色 从最深 到最浅
              "#fff",
              "#a1c2f0",
              "#90b7ed",
              "#91b8ed",
              "#4386e0", //蓝色 最大
              "#fdd4d5",
              "#fcb2b5",
              "#fbadb0",
              "#fcb1b4", //粉色最大
            ],
            //取值范围的颜色
          },
          show: true, //图注
        },
        timeline: {
          // 时间轴样式
          axisType: "category",
          data: this.timeAarry,
          playInterval: 5000,
          bottom: "0",
          symbolSize: 10,
          autoPlay: false,
          loop: true,
          realtime: true,
          lineStyle: {
            color: "#466872",
            width: 2,
          },
          label: {
            color: "#5cc5da",
            fontSize: 14,
          },
        },
        geo: {
          center: [101.114129, 31.850339],
          map: "world", //引入地图数据
          roam: true, //不开启缩放和平移
          zoom: 4, //视角缩放比例
          label: {
            normal: {
              show: true,
              fontSize: "10",
              color: "rgba(0,0,0,0.7)",
            },
          },

          bmap: {
            center: [120.648278, 31.373826], //地图的中心点
            zoom: 12, //地图的等级
            roam: true,
            mapStyle: {
              //地图的样式，可根据需要配置
              style: "midnight",
            },
          },
          itemStyle: {
            normal: {
              borderColor: "rgba(0, 0, 0, 0.2)",
            },
            emphasis: {
              //高亮的显示设置
              areaColor: "skyblue", //鼠标选择区域颜色
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              shadowBlur: 20,
              borderWidth: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        },
        // 鼠标悬浮提示框
        series: [
          {
            // 图形上的文本标签
            label: {
              show: false, // 是否显示对应地名
            },

            name: "国家",
            type: "map",
            geoIndex: 0,
            data: this.dataList,
          },
          // {
          //   data: [
          //     {
          //       value: [118.791334, 32.050214], //指定散点使用的坐标系统为geo坐标系统
          //       itemStyle: {
          //         //小点点颜色
          //         color: "red",
          //       },
          //       symbol: "./flag.png",
          //     },
          //   ],
          //   coordinateSystem: "geo", //指定散点使用的坐标系统为geo坐标系统
          //   type: "effectScatter", //小圆点的动画类型
          //   // rippleEffect: {
          //   //   //涟漪的长度颜色
          //   //   scale: 80,
          //   //   color: "yellow",
          //   // },
          // },
          {
            type: "scatter",
            geoIndex: 0,
            coordinateSystem: "geo",
            hoverAnimation: false,
            symbolSize: 30,
            symbol: "image://" + require("@/assets/image/基地.png"), // require引入图片路径
            label: {
              // show: true,
              color: "#00e5ff",
              offset: [0, 0],
              fontSize: 18,
            },
            data: [],
            zlevel: 3,
          },
          {
            type: "scatter",
            geoIndex: 0,
            coordinateSystem: "geo",
            hoverAnimation: false,
            symbolSize: 30,
            symbol: "image://" + require("@/assets/image/01.png"), // require引入图片路径
            label: {
              // show: true,
              color: "#00e5ff",
              offset: [0, 0],
              fontSize: 18,
            },
            data: [],
            zlevel: 3,
          },
          {
            // 这个就是普通连线
            type: "lines",
            coordinateSystem: "geo", // 这句的意思是连线是基于地理坐标的,geo组件将在下面给出
            polyline: true, // 这表示连线是否为多端点的连线
            data: this.busLines, // 这里就是连线的数据了 上面组装的数据就在这里使用
            effect: {
              show: true,
              period: 6,
              trailLength: 0.7,
              color: "red",
              symbol: planePath,
              symbolSize: 10,
            },
            lineStyle: {
              normal: {
                opacity: 1,
                width: 2,
              },
            },
            progressiveThreshold: 500,
            progressive: 200,
          },
          {
            type: "lines", // 这里还有一个连线其实是做的在线上的一个流动效果，运行代码注意观察你就会看到
            coordinateSystem: "geo",
            polyline: true,
            data: this.busLines,
            lineStyle: {
              normal: {
                width: 0,
              },
            },
            effect: {
              constantSpeed: 20,
              show: true,
              trailLength: 0.1,
              symbolSize: 1.5,
            },
            zlevel: 1,
          },
        ],
      };
      this.options = option;
      this.myChart.setOption(option);
      this.myChart.on("click", (params) => {
        if (params.name !== "基地信息") {
          return;
        }
        console.log(params, "params");
        let that = this;
        that.tranLeft = params.event.event.pageX - 300 + "px";
        that.tranTop = params.event.event.pageY - 200 + "px";
        this.informationcard = params.value;
        // 点击的时候显示模态框
        that.showBox = true;
        if (!params.data?.ename) {
          // alert("暂无" + params.name + "地图数据");
          return;
        }
        _this.$router.push({
          path: "/province",
          query: { provinceName: params.data.ename, province: params.name },
        });
      });
      this.myChart.on("timelinechanged", (param) => {
        const geo = this.geoList[param.currentIndex];
        // console.log("geo",geo);
        const geoseries = [];
        for (var i = 0; i < geo.length; i++) {
          geoseries.push({
            name: "基地信息",
            value: Object.values(geo[i]),
          });
        }
        let _option = this.myChart.getOption();
        // 重新赋值
        _option.series[1].data = geoseries;
        // // 加载数据
        this.myChart.setOption(_option);
        console.log("geoseries", geoseries);
      });
    },
  },
};
</script>

<style scoped>
.bar {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.el-select .el-input {
  width: 130px;
}
.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
.infoWindow {
  padding: 5px;
  width: 280px;
  height: 130px;
  background: white;
  position: absolute;
  z-index: 99;
  color: white;
  box-shadow: 0 0 1.5em rgb(188 230 236 / 50%) inset;
  background-color: #212a4b;
  border-radius: 5px;
  font-family: "Open Sans", HelveticaNeue-Light, "Helvetica Neue Light",
    "Helvetica Neue", Helvetica, Arial, sans-serif;
}
</style>